export enum WiseTransferRail {
    SortCode = 'sort_code',
    ACH = 'aba',
    IBAN = 'iban',
    AUSTRALIAN = 'australian',
    SWIFT = 'swift_code',
    ACSS = 'canadian',
    EMIRATES = 'emirates',
    SINGAPORE = 'singapore',
    NEW_ZEALAND = 'newzealand',
    HONG_KONG = 'hongkong',
}
